const LARGE_BUTTON = {
    height: 40,
    fontSize: 14,
};
const MEDIUM_BUTTON = {
    height: 32,
    fontSize: 13,
};
const SMALL_BUTTON = {
    height: 24,
    fontSize: 13,
};
const XSMALL_BUTTON = {
    height: 20,
    fontSize: 13,
};

// These are only used in tests, and only reflect Lodestar sizing.
export const BUTTON_STYLE_PROPERTIES_BY_SIZE_MAP = {
    large: LARGE_BUTTON,
    medium: MEDIUM_BUTTON,
    small: SMALL_BUTTON,
    xsmall: XSMALL_BUTTON,
};

export const cssBaseBackgroundVar = "--sds--button--color--background";
export const cssBackgroundRestVar = "--sds--button--color--background--rest";
export const cssBackgroundHoverVar = "--sds--button--color--background--hover";
export const cssTextRestVar = "--sds--button--color--text--rest";
export const cssBaseTextVar = "--sds--button--color--text";
export const cssBaseBorderVar = "--sds--button--color--border";
export const cssBackgroundActiveVar = "--sds--button--color--background--active";
